import React from 'react';

import additionalDefaultSvgAttributes from './defaultSvgAttributes.js';

import Account from './account.svg';
const DefaultedAccount = (props) => <Account {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedAccount as Account };

import AngleBottom from './angle-bottom.svg';
const DefaultedAngleBottom = (props) => <AngleBottom {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedAngleBottom as AngleBottom };

import AngleDown from './angle-down.svg';
const DefaultedAngleDown = (props) => <AngleDown {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedAngleDown as AngleDown };

import AngleEnd from './angle-end.svg';
const DefaultedAngleEnd = (props) => <AngleEnd {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedAngleEnd as AngleEnd };

import AngleLeft from './angle-left.svg';
const DefaultedAngleLeft = (props) => <AngleLeft {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedAngleLeft as AngleLeft };

import AngleRight from './angle-right.svg';
const DefaultedAngleRight = (props) => <AngleRight {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedAngleRight as AngleRight };

import AngleTop from './angle-top.svg';
const DefaultedAngleTop = (props) => <AngleTop {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedAngleTop as AngleTop };

import AngleUp from './angle-up.svg';
const DefaultedAngleUp = (props) => <AngleUp {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedAngleUp as AngleUp };

import Bell from './bell.svg';
const DefaultedBell = (props) => <Bell {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedBell as Bell };

import Billing from './billing.svg';
const DefaultedBilling = (props) => <Billing {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedBilling as Billing };

import Calendar from './calendar.svg';
const DefaultedCalendar = (props) => <Calendar {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedCalendar as Calendar };

import Checkmark from './checkmark.svg';
const DefaultedCheckmark = (props) => <Checkmark {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedCheckmark as Checkmark };

import CheckmarkCircle from './checkmark-circle.svg';
const DefaultedCheckmarkCircle = (props) => <CheckmarkCircle {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedCheckmarkCircle as CheckmarkCircle };

import Cog from './cog.svg';
const DefaultedCog = (props) => <Cog {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedCog as Cog };

import Copy from './copy.svg';
const DefaultedCopy = (props) => <Copy {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedCopy as Copy };

import Download from './download.svg';
const DefaultedDownload = (props) => <Download {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedDownload as Download };

import Envelope from './envelope.svg';
const DefaultedEnvelope = (props) => <Envelope {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedEnvelope as Envelope };

import ExclamationCircle from './exclamation-circle.svg';
const DefaultedExclamationCircle = (props) => <ExclamationCircle {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedExclamationCircle as ExclamationCircle };

import ExclamationDiamond from './exclamation-diamond.svg';
const DefaultedExclamationDiamond = (props) => <ExclamationDiamond {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedExclamationDiamond as ExclamationDiamond };

import ExclamationTriangle from './exclamation-triangle.svg';
const DefaultedExclamationTriangle = (props) => <ExclamationTriangle {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedExclamationTriangle as ExclamationTriangle };

import ExternalLink from './external-link.svg';
const DefaultedExternalLink = (props) => <ExternalLink {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedExternalLink as ExternalLink };

import File from './file.svg';
const DefaultedFile = (props) => <File {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedFile as File };

import Filter from './filter.svg';
const DefaultedFilter = (props) => <Filter {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedFilter as Filter };

import Flag from './flag.svg';
const DefaultedFlag = (props) => <Flag {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedFlag as Flag };

import Globe from './globe.svg';
const DefaultedGlobe = (props) => <Globe {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedGlobe as Globe };

import HelpCircle from './help-circle.svg';
const DefaultedHelpCircle = (props) => <HelpCircle {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedHelpCircle as HelpCircle };

import InfoCircle from './info-circle.svg';
const DefaultedInfoCircle = (props) => <InfoCircle {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedInfoCircle as InfoCircle };

import InputFile from './input-file.svg';
const DefaultedInputFile = (props) => <InputFile {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedInputFile as InputFile };

import InputTime from './input-time.svg';
const DefaultedInputTime = (props) => <InputTime {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedInputTime as InputTime };

import KbdArrowDown from './kbd-arrow-down.svg';
const DefaultedKbdArrowDown = (props) => <KbdArrowDown {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedKbdArrowDown as KbdArrowDown };

import KbdArrowLeft from './kbd-arrow-left.svg';
const DefaultedKbdArrowLeft = (props) => <KbdArrowLeft {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedKbdArrowLeft as KbdArrowLeft };

import KbdArrowRight from './kbd-arrow-right.svg';
const DefaultedKbdArrowRight = (props) => <KbdArrowRight {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedKbdArrowRight as KbdArrowRight };

import KbdArrowUp from './kbd-arrow-up.svg';
const DefaultedKbdArrowUp = (props) => <KbdArrowUp {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedKbdArrowUp as KbdArrowUp };

import KbdCapslock from './kbd-capslock.svg';
const DefaultedKbdCapslock = (props) => <KbdCapslock {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedKbdCapslock as KbdCapslock };

import KbdCommand from './kbd-command.svg';
const DefaultedKbdCommand = (props) => <KbdCommand {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedKbdCommand as KbdCommand };

import KbdDelete from './kbd-delete.svg';
const DefaultedKbdDelete = (props) => <KbdDelete {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedKbdDelete as KbdDelete };

import KbdEject from './kbd-eject.svg';
const DefaultedKbdEject = (props) => <KbdEject {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedKbdEject as KbdEject };

import KbdOption from './kbd-option.svg';
const DefaultedKbdOption = (props) => <KbdOption {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedKbdOption as KbdOption };

import KbdReturn from './kbd-return.svg';
const DefaultedKbdReturn = (props) => <KbdReturn {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedKbdReturn as KbdReturn };

import KbdShift from './kbd-shift.svg';
const DefaultedKbdShift = (props) => <KbdShift {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedKbdShift as KbdShift };

import KbdSpace from './kbd-space.svg';
const DefaultedKbdSpace = (props) => <KbdSpace {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedKbdSpace as KbdSpace };

import KbdTab from './kbd-tab.svg';
const DefaultedKbdTab = (props) => <KbdTab {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedKbdTab as KbdTab };

import Key from './key.svg';
const DefaultedKey = (props) => <Key {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedKey as Key };

import Lock from './lock.svg';
const DefaultedLock = (props) => <Lock {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedLock as Lock };

import MimeArchive from './mime-archive.svg';
const DefaultedMimeArchive = (props) => <MimeArchive {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedMimeArchive as MimeArchive };

import MimeAudio from './mime-audio.svg';
const DefaultedMimeAudio = (props) => <MimeAudio {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedMimeAudio as MimeAudio };

import MimeCode from './mime-code.svg';
const DefaultedMimeCode = (props) => <MimeCode {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedMimeCode as MimeCode };

import MimeData from './mime-data.svg';
const DefaultedMimeData = (props) => <MimeData {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedMimeData as MimeData };

import MimeImage from './mime-image.svg';
const DefaultedMimeImage = (props) => <MimeImage {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedMimeImage as MimeImage };

import MimeSystem from './mime-system.svg';
const DefaultedMimeSystem = (props) => <MimeSystem {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedMimeSystem as MimeSystem };

import MimeText from './mime-text.svg';
const DefaultedMimeText = (props) => <MimeText {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedMimeText as MimeText };

import MimeVideo from './mime-video.svg';
const DefaultedMimeVideo = (props) => <MimeVideo {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedMimeVideo as MimeVideo };

import MinusCircle from './minus-circle.svg';
const DefaultedMinusCircle = (props) => <MinusCircle {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedMinusCircle as MinusCircle };

import Minus from './minus.svg';
const DefaultedMinus = (props) => <Minus {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedMinus as Minus };

import Monitoring from './monitoring.svg';
const DefaultedMonitoring = (props) => <Monitoring {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedMonitoring as Monitoring };

import Paperclip from './paperclip.svg';
const DefaultedPaperclip = (props) => <Paperclip {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedPaperclip as Paperclip };

import Payment from './payment.svg';
const DefaultedPayment = (props) => <Payment {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedPayment as Payment };

import Phone from './phone.svg';
const DefaultedPhone = (props) => <Phone {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedPhone as Phone };

import PlusOrMinus from './plus-or-minus.svg';
const DefaultedPlusOrMinus = (props) => <PlusOrMinus {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedPlusOrMinus as PlusOrMinus };

import Plus from './plus.svg';
const DefaultedPlus = (props) => <Plus {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedPlus as Plus };

import Search from './search.svg';
const DefaultedSearch = (props) => <Search {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedSearch as Search };

import ServerConfig from './server-config.svg';
const DefaultedServerConfig = (props) => <ServerConfig {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedServerConfig as ServerConfig };

import ServerIncident from './server-incident.svg';
const DefaultedServerIncident = (props) => <ServerIncident {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedServerIncident as ServerIncident };

import Server from './server.svg';
const DefaultedServer = (props) => <Server {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedServer as Server };

import SortDown from './sort-down.svg';
const DefaultedSortDown = (props) => <SortDown {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedSortDown as SortDown };

import SortUp from './sort-up.svg';
const DefaultedSortUp = (props) => <SortUp {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedSortUp as SortUp };

import Sort from './sort.svg';
const DefaultedSort = (props) => <Sort {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedSort as Sort };

import Support from './support.svg';
const DefaultedSupport = (props) => <Support {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedSupport as Support };

import Tag from './tag.svg';
const DefaultedTag = (props) => <Tag {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedTag as Tag };

import Ticketing from './ticketing.svg';
const DefaultedTicketing = (props) => <Ticketing {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedTicketing as Ticketing };

import TimesCircle from './times-circle.svg';
const DefaultedTimesCircle = (props) => <TimesCircle {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedTimesCircle as TimesCircle };

import Times from './times.svg';
const DefaultedTimes = (props) => <Times {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedTimes as Times };

import Trash from './trash.svg';
const DefaultedTrash = (props) => <Trash {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedTrash as Trash };

import Upload from './upload.svg';
const DefaultedUpload = (props) => <Upload {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedUpload as Upload };

import User from './user.svg';
const DefaultedUser = (props) => <User {...additionalDefaultSvgAttributes} {...props} />;
export { DefaultedUser as User };

// Custom Use Icons
import Arrow from './Arrow.jsx';
export { Arrow };

import ErrorIcon from './ErrorIcon.jsx';
export { ErrorIcon };

import Pencil from './Pencil.jsx';
export { Pencil };
